import { PARTNERS } from "@/lib/site";

export default function Partners() {
    return (
        <section
            id="partners"
            data-testid="partners-section"
            className="py-24 md:py-32 lg:py-40"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12">
                    <div className="col-span-12 md:col-span-4">
                        <span className="number-mark text-ink2">§ 06</span>
                        <h2
                            data-testid="partners-heading"
                            className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] text-ink"
                        >
                            Who we
                            <br />
                            work with.
                        </h2>
                        <p className="mt-8 text-ink2 text-[16px] leading-relaxed max-w-sm">
                            We work best where there is a genuine commitment to
                            Indigenous leadership, long-term outcomes and
                            practical delivery on Country.
                        </p>
                    </div>

                    <div className="col-span-12 md:col-span-8 md:pl-12">
                        <ul
                            data-testid="partners-list"
                            className="divide-y divide-rule border-t border-b border-rule"
                        >
                            {PARTNERS.map((p, i) => (
                                <li
                                    key={p}
                                    data-testid={`partner-${i}`}
                                    className="py-5 md:py-6 flex items-baseline justify-between group hover:text-ochre transition-colors"
                                >
                                    <span className="font-serif text-2xl md:text-3xl lg:text-[34px] leading-[1.1] text-ink group-hover:text-ochre transition-colors">
                                        {p}
                                    </span>
                                    <span className="number-mark text-ink2">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
